import { useCallback, useRef, useState } from 'react';

function useIsStuck() {
  const [isStuck, setIsStuck] = useState(false);
  const observerRef = useRef(null);

  const setRef = useCallback((node) => {
    if (observerRef.current) {
      observerRef.current.disconnect();
      observerRef.current = null;
    }
    if (node && typeof IntersectionObserver !== 'undefined') {
      observerRef.current = new IntersectionObserver(([entry]) => {
        setIsStuck(!entry.isIntersecting);
      });
      observerRef.current.observe(node);
    }
  }, []);

  return [setRef, isStuck];
}

export default useIsStuck;
